"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { OAuthButton } from "@/components/auth/oauth-button";
import { Logo } from "@/components/logo";
import { useAuthCallback } from "@/hooks/use-auth-callback";
import { analytics } from "@/lib/analytics/client";
import { getEnabledProviders } from "@/lib/oauth";
import { useSession } from "@domainstack/auth/client";
import { Icon } from "@domainstack/ui/icon";
import { cn } from "@domainstack/ui/utils";
interface LoginContentProps {
  /** Additional classes for the wrapper */
  className?: string;
  /** Callback when navigating away (e.g., to close modal) */
  onNavigate?: () => void;
  /** URL to redirect to after successful sign-in (defaults to current page or /dashboard) */
  callbackURL?: string;
}
export function LoginContent(t0) {
  const $ = _c(33);
  const {
    className,
    onNavigate,
    callbackURL
  } = t0;
  const [loadingProvider, setLoadingProvider] = useState(null);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    data: session,
    isPending
  } = useSession();
  useAuthCallback();
  let t1;
  if ($[0] !== isPending || $[1] !== pathname || $[2] !== session?.user) {
    t1 = () => {
      if (isPending || session?.user) {
        return;
      }
      analytics.track("signup_pageview", {
        pathname
      });
    };
    $[0] = isPending;
    $[1] = pathname;
    $[2] = session?.user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = session?.user;
  let t3;
  if ($[4] !== isPending || $[5] !== pathname || $[6] !== t2) {
    t3 = [isPending, pathname, t2];
    $[4] = isPending;
    $[5] = pathname;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t1, t3);
  let t4;
  if ($[8] !== callbackURL || $[9] !== pathname || $[10] !== searchParams) {
    t4 = callbackURL ?? (["/", "/login"].includes(pathname) ? "/dashboard" : pathname + (searchParams.toString() ? `?${searchParams.toString()}` : ""));
    $[8] = callbackURL;
    $[9] = pathname;
    $[10] = searchParams;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const effectiveCallbackURL = t4;
  let t5;
  if ($[12] !== className) {
    t5 = cn("flex flex-col items-center", className);
    $[12] = className;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  let t7;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon size="xl" variant="muted" className="mb-5"><Logo /></Icon>;
    t7 = <h1 className="mb-2 text-xl font-semibold tracking-tight">Welcome to Domainstack</h1>;
    t8 = <p className="mb-6 text-center text-sm text-muted-foreground">Sign in to track your domains and receive health alerts.</p>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
  }
  let t9;
  if ($[17] !== effectiveCallbackURL || $[18] !== loadingProvider) {
    t9 = getEnabledProviders().map(provider => <OAuthButton key={provider.id} provider={provider} callbackURL={effectiveCallbackURL} isLoading={loadingProvider === provider.id} isAnyLoading={loadingProvider !== null} onLoadingChange={loading => setLoadingProvider(loading ? provider.id : null)} />);
    $[17] = effectiveCallbackURL;
    $[18] = loadingProvider;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <div className="flex w-full flex-col gap-3">{t9}</div>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== onNavigate) {
    t11 = <Link href="/terms" onClick={onNavigate} className="underline underline-offset-2 hover:text-foreground">Terms of Service</Link>;
    $[22] = onNavigate;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== onNavigate) {
    t12 = <Link href="/privacy" onClick={onNavigate} className="underline underline-offset-2 hover:text-foreground">Privacy Policy</Link>;
    $[24] = onNavigate;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <p className="mt-6 text-center text-xs leading-relaxed text-muted-foreground">By signing in, you agree to our{" "}{t11}{" "}and{" "}{t12}.</p>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t13 || $[31] !== t5) {
    t14 = <div className={t5}>{t6}{t7}{t8}{t10}{t13}</div>;
    $[29] = t10;
    $[30] = t13;
    $[31] = t5;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}